module.exports = __webpack_public_path__ + "static/img/level2_three_img.0225ca4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/activity/activity20240117/level2_three_img.png
// module id = X4m6
// module chunks = 0